<div class="modal-header">
	<h4 data-i18n="common.upload"></h4>
</div>
<div class="modal-body"></div>
